"use client";

import { useEffect } from "react";
import { useAuth } from "@/features/auth";
import { identify } from "./client";

export function IdentifyCurrentUser() {
  const { user, organization } = useAuth();
  const userId = user?.id;
  const userEmail = user?.email;
  const userName = user?.full_name;
  const userRole = user?.role;
  const groupId = organization?.id;
  const groupName = organization?.name;

  useEffect(() => {
    if (!userId) return;
    identify({
      id: userId,
      email: userEmail,
      username: userName,
      role: userRole,
      ...(groupId ? { group_id: groupId } : {}),
      ...(groupName ? { group_name: groupName } : {}),
    });
  }, [userId, userEmail, userName, userRole, groupId, groupName]);

  return null;
}
